var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.10352e-05C1.79086 6.10352e-05 0 1.79092 0 4.00006V12.0001C0 12.5523 0.447715 13.0001 1 13.0001C1.55228 13.0001 2 12.5523 2 12.0001V4.00006C2 2.89549 2.89543 2.00006 4 2.00006H12C12.5523 2.00006 13 1.55235 13 1.00006C13 0.447776 12.5523 6.10352e-05 12 6.10352e-05H4ZM24 12.0001C24 11.4478 23.5523 11.0001 23 11.0001C22.4477 11.0001 22 11.4478 22 12.0001V20.0001C22 21.1046 21.1046 22.0001 20 22.0001H12C11.4477 22.0001 11 22.4478 11 23.0001C11 23.5523 11.4477 24.0001 12 24.0001H20C22.2091 24.0001 24 22.2092 24 20.0001V12.0001ZM21.3754 4.28954L19.7171 2.63132C19.3246 2.23885 18.6876 2.24111 18.2979 2.63637L17.1822 3.76802L20.244 6.8298L21.3737 5.70544C21.7658 5.31519 21.7666 4.68072 21.3754 4.28954ZM2 19.1674L15.7781 5.19228L18.8264 8.24064L5.00144 22H2L2 19.1674ZM21.1313 1.21709L22.7896 2.8753C23.9632 4.04884 23.9609 5.95225 22.7846 7.12301L6.11968 23.7088L5.82708 24H5.41426L0.999999 24L0 24V23V18.7574V18.3473L0.287889 18.0553L16.8737 1.23224C18.0428 0.046459 19.9539 0.0396572 21.1313 1.21709Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.80b77adaa81c321ce01bac432a442e4e.svg";